import { supabase } from './supabase';
import { UserProfile as ProfileWithRole } from './types';

export const fetchUserProfile = async (userId: string): Promise<ProfileWithRole | null> => {
  
  if (!userId) {
    console.warn('[AuthUtils-Split] fetchUserProfile chamado sem userId.');
    return null;
  }
  
  try {
      const { data: profileOnly, error: profileError } = await supabase
      .from('user_profiles') 
      .select('*, role_id')  
      .eq('user_id', userId) 
      .maybeSingle<Omit<ProfileWithRole, 'role'>>(); 

    // Tratar erro na busca do perfil base
    if (profileError) {
      console.error('[AuthUtils-Split Profile Query] Erro ao buscar perfil base:', profileError);
      return null;
    }

    // Tratar caso onde o perfil simplesmente não existe
    if (!profileOnly) {
       console.log(`[AuthUtils-Split Profile Query] Nenhum perfil encontrado para ${userId}.`);
       return null;
    }

    let roleData: ProfileWithRole['role'] | null = null; // Inicia roleData como null

    if (profileOnly.role_id) {

      let rolesQueryResult: { data: any; error: any; status: number; } | null = null; // Para armazenar a resposta bruta
      let caughtError: any = null; // Para armazenar exceções

      try {
        // Executa a query para buscar a role
        rolesQueryResult = await supabase
          .from('roles') 
          .select('id, role_name, created_at') 
          .eq('id', profileOnly.role_id) 
          .single(); 
      } catch (error) {
        console.error(`[AuthUtils-Split Roles Query] *** EXCEÇÃO Capturada durante a query 'roles':`, error);
        caughtError = error;
      }
      if (caughtError) {
        console.error(`[AuthUtils-Split Roles Query] Erro capturado por try/catch na query 'roles':`, caughtError);
      }

      const roleResultData = rolesQueryResult?.data;
      const roleResultError = rolesQueryResult?.error || caughtError;

      if (roleResultError) {
        console.error(`[AuthUtils-Split Roles Query] Erro FINAL DETECTADO ao buscar role ${profileOnly.role_id}. Definindo role como null. Erro:`, roleResultError);
        roleData = null;
      } else if (roleResultData) {
          roleData = roleResultData;
      } else {
        console.warn('[AuthUtils-Split Roles Query] Nenhum erro reportado, mas os dados da role são nulos/undefined na resposta.');
        roleData = null;
      }

    } else {
      console.log('[AuthUtils-Split] Perfil não possui role_id associado.');
      roleData = null;
    }

    const combinedProfile: ProfileWithRole = {
      ...profileOnly, 
      role: roleData, 
    };
      return combinedProfile; 
    
  } catch (error) {
    console.error('[AuthUtils-Split] Exceção inesperada GERAL na função fetchUserProfile:', error);
    return null;
  }
};

export const isSessionValid = (session: import('@supabase/supabase-js').Session | null): boolean => {
    if (!session) return false;
    if (session.expires_at) {
        const expiresAtMs = session.expires_at * 1000;
        const now = Date.now();
        const margin = 5 * 1000;
        if (now >= expiresAtMs - margin) {
            console.warn('[AuthUtils] Session has expired or is about to expire.');
            return false;
        }
    }
    return true;
};